var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Schema, type } from "@colyseus/schema";
/** A connected watcher of the room. Spectators are connection-scoped identity
 * only — no seat, no economy, no view-gated state — so unlike `Player` this is
 * never persisted; the map empties naturally as sockets close. */
export class Spectator extends Schema {
    constructor() {
        super(...arguments);
        /** Session id (the map key, mirrored for convenience). */
        this.id = "";
        this.name = "";
    }
}
__decorate([
    type("string")
], Spectator.prototype, "id", void 0);
__decorate([
    type("string")
], Spectator.prototype, "name", void 0);
//# sourceMappingURL=Spectator.js.map